<template>
  <v-alert color="rgba(0,0,0,0)">
    <v-row v-if="false">
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="mailto:mario@marionovak.com">
          <h2>Mail</h2>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="/file/cv.pdf">
          <h2>CV.pdf</h2>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://github.com/moltouni">
          <h3>GitHub</h3>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://www.linkedin.com/in/moltouni/">
          <h3>LinkedIn</h3>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://medium.com/@moltouni">
          <h3>Medium</h3>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://twitter.com/@moltouni">
          <h3>Twitter</h3>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://www.mixcloud.com/moltouni/">
          <h3>MixCloud</h3>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://dev.to/moltouni">
          <h3>Dev.to</h3>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://soundcloud.com/moltouni">
          <h3>SoundCloud</h3>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://youtube.com/moltouni">
          <h3>YouTube</h3>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://www.patreon.com/moltouni">
          <h3>Patreon - Monthly</h3>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-btn block x-large href="https://www.buymeacoffee.com/moltouni">
          <h3>Buy Me A Coffee - Once</h3>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col cols="12" sm="12" md="12">
        <v-btn x-large  href="https://andromeda.technology" block>
          <h3>Andromeda.Technology</h3>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "LinksComponent",
  components: {
    //
  },
});
</script>
